<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title> Ajouter des phases </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <div class="d-flex flex-wrap ga-2">
            <v-chip
              v-for="selectedPhase in selectedPhases"
              :key="selectedPhase.id"
              :closable="!selectedPhase.selected"
              @update:model-value="removePhase(selectedPhase)"
            >
              {{ selectedPhase.code }} {{ selectedPhase.name }}
            </v-chip>
          </div>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field label="Recherche" v-model="searchValue" clearable @click:clear="resetFilter"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-0" :gap="0">
          <v-col cols="3" class="d-flex pa-0" v-for="phase in filteredPhases" :key="phase.id">
            <div class="phase-name-container">
              <span class="phase-name-block">
                <span
                  :class="[
                    'phase-name-text',
                    phase.selected ? 'selected' : '',
                    phase.selectedNew ? 'selected-new' : '',
                  ]"
                  @click="addPhase(phase)"
                >
                  {{ phase.code }} {{ phase.name }}
                </span>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="elevated" @click.stop="cancel">Annuler</v-btn>
      <v-btn color="primary" variant="elevated" @click.stop="confirm">Confirmer</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { GetAllPhases } from '@/_services/phases';
import { DialogPropsMixin } from '@/components/dialog/mixins';

export default {
  name: 'PhaseAddModal',
  mixins: [DialogPropsMixin],
  data() {
    return {
      allPhases: [],
      availablePhases: [],
      filteredPhases: [],
      selectedPhases: [],
      searchValue: '',
    };
  },
  methods: {
    fetchAllPhases() {
      this.$emit('loading');

      GetAllPhases()
        .then(rep => {
          const availablePhases = rep.data.map(x => ({
            ...x,
            selected: false,
            selectedNew: false,
          }));

          const selectedPhases = this.payload.phases.map(x => ({
            ...x,
            selected: true,
            selectedNew: false,
          }));

          const availablePhasesFiltered = availablePhases.filter(x => !selectedPhases.some(d => d.id === x.id));

          this.selectedPhases = selectedPhases;
          this.availablePhases = availablePhasesFiltered;
          this.allPhases = selectedPhases.concat(availablePhasesFiltered);
          this.filteredPhases = this.allPhases;
        })
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.$emit('loading', false);
        });
    },
    resetFilter() {
      this.searchValue = '';
      this.filteredPhases = this.allPhases;
    },
    filterPhases() {
      if (this.searchValue !== null) {
        const search = this.searchValue.toLowerCase();

        this.filteredPhases = this.allPhases.filter(({ name }) => name.toLowerCase().includes(search));
      }
    },
    addPhase(phase) {
      if (!this.selectedPhases.includes(phase)) {
        this.selectedPhases.push(phase);
        const phaseIndex = this.filteredPhases.indexOf(phase);
        this.filteredPhases[phaseIndex].selectedNew = true;
      }
    },
    removePhase(selectedPhase) {
      const selectedPhaseIndex = this.selectedPhases.indexOf(selectedPhase);
      this.selectedPhases.splice(selectedPhaseIndex, 1);
      const phaseIndex = this.filteredPhases.indexOf(selectedPhase);
      this.filteredPhases[phaseIndex].selectedNew = false;
    },
    cancel() {
      this.searchValue = '';
      this.$emit('close');
    },
    confirm() {
      this.$store.dispatch(
        'job/addPhases',
        this.selectedPhases.filter(x => !x.selected),
      );
      this.$emit('close');
    },
  },
  watch: {
    searchValue() {
      this.filterPhases();
    },
  },
  mounted() {
    this.fetchAllPhases();
  },
};
</script>
